// ハンバーガーメニュー
document.addEventListener("DOMContentLoaded", () => {
	const BREAKPOINT = 768;
	const ham = document.querySelector(".header__ham");
	const nav = document.querySelector(".gnav");
	const navLink = nav?.querySelector(".gnav__link");
	let isOpen = false;
	let scrollPos = 0;

	if (!ham || !nav) return;

	// SP側判定（<= BREAKPOINT）
	const mqMax = window.matchMedia(`(max-width: ${BREAKPOINT}px)`);
	// PC側判定（> BREAKPOINT）
	const mqMin = window.matchMedia(`(min-width: ${BREAKPOINT + 1}px)`);

	// 初期チェック：PCなら非表示、SPなら表示
	if (mqMax.matches) {
		nav.setAttribute("hidden", "");
	} else {
		nav.removeAttribute("hidden");
	}

	// 幅が BREAKPOINT 以下になったら（SP化）ナビを隠す
	mqMax.addEventListener("change", (e) => {
		if (e.matches) {
			if (!isOpen) nav.setAttribute("hidden", "");
		}
	});

	// 幅が BREAKPOINT を超えたら（PC化）表示＆状態リセット
	mqMin.addEventListener("change", (e) => {
		if (e.matches) {
			nav.removeAttribute("hidden");
			nav.classList.remove("is-active");
			isOpen = false;
			ham.classList.remove("is-active");
			ham.setAttribute("aria-expanded", "false");
		}
	});

	function lockScroll() {
		scrollPos = window.scrollY || window.pageYOffset;
		Object.assign(document.body.style, {
			position: "fixed",
			top: `-${scrollPos}px`,
			left: "0",
			right: "0",
			width: "100%",
		});
	}

	function unlockScroll() {
		const html = document.documentElement;
		const prev = html.style.scrollBehavior;

		html.style.scrollBehavior = "auto";
		Object.assign(document.body.style, {
			position: "",
			top: "",
			left: "",
			right: "",
			width: "",
		});
		window.scrollTo({ top: scrollPos, left: 0, behavior: "auto" });
		requestAnimationFrame(() => {
			html.style.scrollBehavior = prev;
		});
	}

	// 開く
	function openMenu() {
		if (isOpen) return;
		isOpen = true;

		lockScroll();

		ham.classList.add("is-active");
		ham.setAttribute("aria-expanded", "true");

		nav.removeAttribute("hidden");
		void nav.offsetWidth;
		requestAnimationFrame(() => {
			nav.classList.add("is-active");
			navLink?.focus();
		});
	}

	// 閉じる
	function closeMenu() {
		if (!isOpen) return;
		isOpen = false;

		ham.classList.remove("is-active");
		ham.setAttribute("aria-expanded", "false");

		nav.classList.remove("is-active");

		nav.addEventListener(
			"transitionend",
			(e) => {
				if (e.target !== nav) return;
				nav.setAttribute("hidden", "");
			},
			{ once: true }
		);

		unlockScroll();
		ham.focus();
	}

	// トグル
	function toggleMenu() {
		if (window.innerWidth > BREAKPOINT) return;
		isOpen ? closeMenu() : openMenu();
	}

	ham.addEventListener("click", toggleMenu);

	// メニュー内リンクで閉じる
	nav.addEventListener("click", (e) => {
		if (e.target.closest("a.gnav__link") || e.target.closest("a.subnav__link")) {
			closeMenu();
		}
	});

	// 外側クリックで閉じる
	document.addEventListener("click", (e) => {
		if (isOpen && !e.target.closest(".header__ham") && !e.target.closest(".gnav")) {
			closeMenu();
		}
	});

	// Escキーで閉じる
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && isOpen) closeMenu();
	});

	// 初期ARIA
	ham.setAttribute("aria-expanded", "false");
});

// 背景装飾
(() => {
	const sections = [...document.querySelectorAll("section")]
		.map((sec) => {
			const bg = sec.querySelector(".bg-glow");
			return bg ? { sec, bg } : null;
		})
		.filter(Boolean);
	if (!sections.length) return;

	const START_SHIFT = -50;
	const END_SHIFT = 0;
	const TARGET_RATIO = 0.1;

	const clamp = (v, min, max) => (v < min ? min : v > max ? max : v);
	let ticking = false;

	function update() {
		const vh = window.innerHeight;

		for (const { sec, bg } of sections) {
			const r = sec.getBoundingClientRect();
			const h = r.height;

			// 進行度の基準:
			// start … section.top === vh（= 上端が画面下端に触れる瞬間）
			// end   … sectionの30%地点が viewportCenter === vh/2 に一致
			//
			// s = vh - r.top は「startからの進み量」
			// s_end = vh/2 + 0.3*h が「end までに必要な進み量」
			const s = vh - r.top;
			const s_end = vh / 2 + TARGET_RATIO * h;

			const t = clamp(s / s_end, 0, 1);

			const y = START_SHIFT + (END_SHIFT - START_SHIFT) * t;
			bg.style.setProperty("transform", `translate3d(0, ${y}%, 0)`);
		}

		ticking = false;
	}

	function onScroll() {
		if (!ticking) {
			ticking = true;
			requestAnimationFrame(update);
		}
	}

	window.addEventListener("scroll", onScroll, { passive: true });
	window.addEventListener("resize", onScroll, { passive: true });

	update(); // 初期反映
})();

// mediaSolution カルーセル
(() => {
	const root = document.querySelector(".mediaSolution__marquee");
	if (!root) return;

	const viewport = root.querySelector(".mediaSolution__marquee-viewport");
	const track = root.querySelector(".mediaSolution__marquee-track");
	const list = root.querySelector(".mediaSolution__marquee-list");
	if (!viewport || !track || !list) return;

	const SPEED = 50;

	const waitImages = () => Promise.all([...list.querySelectorAll("img")].map((img) => (img.complete && img.naturalWidth > 0 ? Promise.resolve() : new Promise((res) => img.addEventListener("load", res, { once: true })))));

	let listWidth = 0;
	let offset = 0;
	let playing = true;
	let rafId = 0;

	const ensureClones = () => {
		const lists = track.querySelectorAll(".mediaSolution__marquee-list");
		if (lists.length > 1) {
			[...lists].forEach((el, i) => i > 0 && el.remove());
		}
		const clone = list.cloneNode(true);
		clone.setAttribute("aria-hidden", "true");
		track.appendChild(clone);

		const vpW = viewport.clientWidth;
		listWidth = list.scrollWidth;
		if (listWidth < vpW) {
			const clone2 = list.cloneNode(true);
			clone2.setAttribute("aria-hidden", "true");
			track.appendChild(clone2);
		}
	};

	const measure = () => {
		listWidth = list.scrollWidth;
	};

	const tick = ((tsPrev) =>
		function loop(ts) {
			if (!playing) {
				rafId = requestAnimationFrame(loop);
				tsPrev = ts;
				return;
			}
			const dt = Math.max(0, ts - (tsPrev ?? ts)) / 1000;
			tsPrev = ts;

			offset -= SPEED * dt;
			if (Math.abs(offset) >= listWidth) {
				offset += listWidth;
			}
			track.style.transform = `translateX(${offset}px)`;
			rafId = requestAnimationFrame(loop);
		})();

	const start = () => {
		cancelAnimationFrame(rafId);
		rafId = requestAnimationFrame(tick);
	};

	const onResize = () => {
		playing = false;
		offset = 0;
		track.style.transform = `translateX(0px)`;
		ensureClones();
		measure();
		playing = true;
		start();
	};
	window.addEventListener("resize", onResize);

	(async () => {
		await waitImages().catch(() => {});
		ensureClones();
		measure();
		start();
	})();
})();

// 記事ページ スライダー
jQuery(function ($) {
	$(".c-single__slider").slick({
		autoplay: true,
		dots: true,
		infinite: true,
		prevArrow: '<button type="button" class="slick-prev"><span></span></button>',
		nextArrow: '<button type="button" class="slick-next"><span></span></button>',
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: "8.5%",
				},
			},
		],
	});
});
